import type { UseMutationOptions } from "react-query";
import { useMutation } from "react-query";
import { t } from "@/i18n-js/instance";
import { authenticationAppRoutes } from "@circle-react/components/OnboardingPage/helpers/routes";
import { reactQueryPost } from "@circle-react/helpers/backendRequestHelpers";
import { useToast } from "@circle-react-uikit/ToastV2";

export interface VerifyOtpResult {
  redirect_url: string;
  current_community_name: string;
  other_community_names: string[] | null;
}

export interface SignInResponse {
  redirectUrl: string;
  currentCommunityName: string;
  otherCommunityNames: string[] | null;
}

export interface VerifyOtpProps {
  setIsVerifyingOtp: (result: boolean) => void;
  isSignupPasswordMatching?: boolean;
  setOtpSignInResponse: (response: SignInResponse) => void;
  options?: UseMutationOptions<any, unknown, any, unknown>;
}

export interface RequestBody {
  user: {
    email: string;
    otp: string;
  };
}

export const useVerifyOtp = ({
  setIsVerifyingOtp,
  isSignupPasswordMatching,
  setOtpSignInResponse,
  options = {},
}: VerifyOtpProps) => {
  const toast = useToast();

  return useMutation(
    (body: RequestBody) => {
      if (body.user.otp.length < 6) {
        throw new Error(t("authentication_app.signin.form.otp_length_error"));
      }
      setIsVerifyingOtp(true);
      return reactQueryPost(authenticationAppRoutes.optSessions(), body);
    },
    {
      onSuccess: (data: VerifyOtpResult) => {
        if (isSignupPasswordMatching) {
          window.location.href = data?.redirect_url;
        } else {
          setOtpSignInResponse({
            redirectUrl: data?.redirect_url,
            currentCommunityName: data?.current_community_name,
            otherCommunityNames: data?.other_community_names,
          });
        }
      },
      onError: (error: any) => {
        setIsVerifyingOtp(false);
        console.error(error);
        toast.error(error.message);
      },
      ...options,
    },
  );
};
